import { Typography } from "@mui/material";
import { useEffect } from "react";

export const PurchaseRedirect = () => {
    // const navigate = useNavigate();
    useEffect(() => {
       setTimeout(() => {
        window.open(sessionStorage.getItem("redirect-url"), "_self");
      }, 3000);
      // return () => clearTimeout(timeout)
    }, []);
    return (
      <Typography padding={"0px"} display="flex" gap="12px" alignItems="center">
        {" "}
        {/* <ButtonOutlined
          onClick={() => navigate("/licence/purchasereview")}
          variant="outlined"
          startIcon={<ArrowBackIcon />}
        >
          {" "}
          Back
        </ButtonOutlined> */}
        Redirecting you to payment....
      </Typography>
    );
  };
  